export default "__VITE_ASSET__50f3e308__"